module.exports = __webpack_public_path__ + "img/qrcode.608530f9.png";